import find from 'lodash/find';

export const isImportant = (value) => value === 'IMPORTANT';
export const containOther = (values) => find(values, value => value?.toLowerCase() === 'other');
